// extracted by mini-css-extract-plugin
module.exports = {"offer":"Offer_offer__2pFZC","icon":"Offer_icon__38uP7","flex":"Offer_flex__e_DR7"};